import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import config from '../../config';

// Styles
import { ContentSection, FooterWrap } from './FooterStyles';

const Footer = ({ light }) => (
  <FooterWrap>
    <ContentSection>
      <div>
        <h5>Quick Links</h5>
        <p><Link to='/'>Home</Link></p>
        <p><Link to='/foods'>Foods</Link></p>
        <p><Link to='/nutrients'>Nutrients & Vitamins</Link></p>
        <p><Link to='/diets'>Diets</Link></p>
      </div>
      <div>
        <h5>Social</h5>
        <p>Twitter</p>
      </div>
      <div>
        <h5>About</h5>
        <p><Link to='/jamstack/tools/'>How was this site built?</Link></p>
      </div>
      <div>
        <h5>Legal</h5>
        <p><Link to='/privacy'>Privacy Policy</Link></p>
        <p>&copy; toomanykiwis.com {(new Date()).getFullYear()}</p>
      </div>
    </ContentSection>
  </FooterWrap>
);

Footer.propsTypes = {};

Footer.defaultProps = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx